import React from 'react';
import { Box } from '@chakra-ui/react';

const Container = (props) => {
    return (
        <Box mx={'auto'} as={'section'} maxW={'1500px'}>
            {props.children}
        </Box>
    );
};

export default Container;
